module.exports = __webpack_public_path__ + "static/media/usericon.ad29bd38.svg";